import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { createInviteUrl } from '@swf/poker';

import {
  TXTCLI_Click_the_XJoin_a_Poker_ClubX__ELL,
  TXTCLI_Enter_my_Club_ID_numberX_N0,
  TXTCLI_Enter_my_Invitation_CodeX_N0,
  TXTCLI_ThatXs_itX_Once_IXve_approved__ELL,
  TXTCLI_You_are_invited_to_join_my_pri_ELL_1
} from './useCopyInstructions.messages.json';

export interface CopyData {
  clubId: number;
  invitationCode: string;
}

const useCopyInstructions = () => {
  const [copied, setCopied] = useState(false);
  const { formatMessage } = useIntl();
  const { routes } = useSelector(select.page.getMeta);

  const handleCopy = ({ clubId, invitationCode }: CopyData) => {
    const url = createInviteUrl(routes, { type: 'JOIN_CLUB', clubId, invitationCode });
    const text = `
      ${formatMessage(TXTCLI_You_are_invited_to_join_my_pri_ELL_1)}

      Launch this URL: ${url} or use our free PokerStars software
      ${formatMessage(TXTCLI_Click_the_XJoin_a_Poker_ClubX__ELL)}
      ${formatMessage(TXTCLI_Enter_my_Club_ID_numberX_N0, { 0: clubId })}
      ${formatMessage(TXTCLI_Enter_my_Invitation_CodeX_N0, { 0: invitationCode })}

      ${formatMessage(TXTCLI_ThatXs_itX_Once_IXve_approved__ELL)}
      `;

    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
      })
      .catch(() => {
        setCopied(false);
      });

    return text;
  };

  const resetCopy = () => {
    if (copied) {
      setCopied(false);
    }
  };
  return { copied, handleCopy, resetCopy };
};

export default useCopyInstructions;
